<template>
    <div class="mb-6" v-show="displayForSubscriptionPlan('premium')">
        <widget-layout
            :graph-title="'Visits by Device'"
            :graph-type="type"
            :graph-values="values"
            :loading-data="haveData"
        ></widget-layout>
    </div>
</template>

<script>
import WidgetLayout from "@/Layouts/WidgetLayout";

export default {
    name: "DevicesGraph",
    components: {
        WidgetLayout,
    },
    props: {
        campaignCode: String,
        referrerCode: String,
        range: {
            type: String,
            default: 'daily'
        }
    },
    data() {
        return {
            haveData: false,
            type: 'doughnut',
            values: {
                labels: [],
                datasets: [
                    {
                        backgroundColor: [],
                        data: []
                    }
                ]
            }
        }
    },
    methods: {
        fetchReport() {
            axios.get('/sanctum/csrf-cookie').then(response => {
                axios.get(route('report.devices', {
                    'range': this.range,
                    'campaign_code': this.campaignCode,
                    'referrer_code': this.referrerCode
                })).then((response) => {
                    let data = response.data.data;
                    this.values.labels = data.labels;
                    this.values.datasets[0].data = data.values;
                    this.values.datasets[0].backgroundColor = data.backgroundColors;
                    this.haveData = true;
                }).catch(err => console.error(err))
            });
        }
    },
    watch: {
        range: function(newVal, oldVal) { // watch it
            this.haveData = false;
            this.values.labels = [];
            this.values.datasets[0].data = [];
            this.values.datasets[0].backgroundColor = [];
            this.fetchReport();
        }
    },
    created() {
        this.fetchReport();
    }
}
</script>

<style scoped>

</style>
